/**
 * Has this person seen "About this page" — the sheet that says, once, what
 * the Ask and Note captions used to say on every visit (Nov 1)?
 *
 * Kept in this browser only. A DSP on a new phone sees it once more; nothing
 * depends on it. Storage can be blocked or throw (private windows): then the
 * sheet simply shows on first use each visit, and the ⓘ always opens it.
 */
const KEY = "cg.aboutSeen.v1";

export function aboutSeen() {
  try { return window.localStorage.getItem(KEY) === "1"; } catch { return false; }
}

export function markAboutSeen() {
  try { window.localStorage.setItem(KEY, "1"); } catch { /* fine */ }
}
